const scrollConfig = {
  behavior: 'smooth',
  block: 'center',
  inline: 'center'
};

const inputErrorMsg = (message) => {
  const messageEl = document.createElement('div');
  messageEl.classList.add('error-message', 'js-error-message');
  messageEl.innerText = message;
  return messageEl;
};

const formErroMessage = (message) => {
  const messageEl = document.createElement('div');
  messageEl.classList.add('warning', 'js-form-warning');
  messageEl.innerHTML += '<span class="icon icon-error"></span>';
  messageEl.innerHTML += message;
  return messageEl;
};

export const cleanInputs = (form, cb) => {
  const inputs = form.querySelectorAll('input, select');
  [...inputs].forEach((el) => {
    const parent = error.parentElement;
    const error = parent.querySelector('.error-message');
    el.classList.remove('error');
    el.removeAttribute('aria-describedby');
    el.removeAttribute('aria-invalid');
    parent.removeChild(error);
  });
};

/**
 * @param {Element}
  */
export const showFieldsErrors = (form, errors) => {
  for (const [key, value] of Object.entries(errors)) {
    const el = form.querySelector(`[name="${key}"]`);
    const parent = el.closest('.js-form-input');
    el.classList.add('error');
    el.setAttribute('aria-describedby', `bouncer-error_${key}`);
    el.setAttribute('aria-invalid', true);
    parent.appendChild(inputErrorMsg(value));
  }
  const error = form.querySelector('.error-message');
  if (error) {
    error.scrollIntoView(scrollConfig);
  }
};

export const showFieldError = (fieldName, message) => {
  const el = document.querySelector(`[name*="${fieldName}"]`);
  const parent = el.closest('.js-form-input');
  el.classList.add('error');
  el.setAttribute('aria-describedby', `bouncer-error_${el.name}`);
  el.setAttribute('aria-invalid', true);
  if (message) parent.appendChild(inputErrorMsg(message));
  parent.scrollIntoView(scrollConfig);
  el.addEventListener('focus', handleFocus, false);
};

const handleFocus = (e) => {
  const el = e.currentTarget;
  const parent = el.parentElement;
  const error = parent.querySelector('.error-message');
  el.classList.remove('error');
  el.removeAttribute('aria-describedby');
  el.removeAttribute('aria-invalid');
  parent.removeChild(error);
  el.removeEventListener('focus', handleFocus, false);
};

export const showGlobalError = (form, error) => {
  const button = form.querySelector('button[type="submit"]');
  const parent = button.parentNode;
  const errorEl = formErroMessage(error);
  parent.insertBefore(errorEl, button);
};
